import { UserIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { Icon } from '@/components/core/Icon';
import { cn } from '@/services/utils';

interface UserAvatarProps {
    imageUrl?: string;
    name?: string;
    size: 'list' | 'dialog';
}

const SIZE_CLASS = {
    list: 'tw-h-9 tw-w-9',
    dialog: 'tw-h-[90px] tw-w-[90px]',
};

export function UserAvatar({ imageUrl, name, size }: UserAvatarProps) {
    const [failed, setFailed] = useState(false);
    const boxClass = SIZE_CLASS[size];

    if (!imageUrl || failed) {
        return (
            <span className={cn('tw-inline-flex tw-items-center tw-justify-center tw-shrink-0', boxClass)}>
                <Icon icon={UserIcon} className={size === 'dialog' ? 'tw-h-12 tw-w-12 lg:tw-h-14 lg:tw-w-14' : 'tw-h-6 tw-w-6'} variant='lighter-gray'/>
            </span>
        );
    }

    return (
        <span className={cn('tw-inline-flex tw-shrink-0 tw-overflow-hidden tw-rounded-full', boxClass)}>
            <img
                src={imageUrl}
                alt={name ?? ''}
                className="tw-h-full tw-w-full tw-object-cover"
                onError={() => setFailed(true)}
            />
        </span>
    );
}
